<template>
  <v-list-item v-if="issue.number !== undefined">
    <v-list-item-title @dblclick="onDoubleClick">
      <v-text-field
        v-if="edit"
        ref="titleInput"
        v-model="title"
        @blur="edit = false"
        @keyup.enter="storeTitle"
      />
      <span v-else :class="{ 'text-decoration-line-through': done }">
        {{ issue.title }}
      </span>
    </v-list-item-title>
    <template #prepend>
      <v-checkbox v-model="done" density="compact" hide-details />
    </template>
    <template #append>
      <a v-if="issue.html_url" :href="issue.html_url"
        ><v-icon>mdi-open-in-new</v-icon></a
      >
    </template>
  </v-list-item>
</template>
<script setup lang="ts">
import { ref, type Ref, watch } from "vue";
import type { Issue } from "../gen/forgejo-vue";
import type { AuthorizationToken } from "@/authenticationTokens";
const props = defineProps<{
  auth: AuthorizationToken;
  repo: string;
  issue: Issue;
}>();
const emit = defineEmits<{
  (e: "change-state", state: "open" | "closed"): void;
  (e: "change-title", title: string): void;
}>();

const done = ref(props.issue.state === "closed");
watch(done, (value) => {
  emit("change-state", value ? "closed" : "open");
});
const edit = ref(false);
const title = ref(props.issue.title);
const titleInput: Ref<HTMLElement | undefined> = ref();
watch(titleInput, () => {
  if (titleInput.value) {
    titleInput.value.focus();
  }
});

function onDoubleClick() {
  edit.value = true;
}
function storeTitle() {
  edit.value = false;
  if (title.value && title.value.trim() !== props.issue.title) {
    emit("change-title", title.value);
  }
}
</script>
